import { combineReducers } from "redux";
import user from "./user.js";
import dialog from "./dialog.js";
import taskRow from "./task-row.js";
import alert from "./alert.js";
import tab from "./tab.js";
import appraisalUser from "./appraisal-user.js";

const reducerList = combineReducers({
  user,
  dialog,
  taskRow,
  alert,
  tab,
  appraisalUser,
});

export default reducerList;
